export const BREAKPOINTS = ['default', 'sm', 'smp', 'md', 'mdp', 'lg', 'xl'] as const;

type Breakpoint = (typeof BREAKPOINTS)[number];

const BREAKPOINTS_MAP: Map<Breakpoint, number> = new Map([
  ['sm', 580],
  ['smp', 720],
  ['md', 960],
  ['mdp', 1136],
  ['lg', 1440],
  ['xl', 1600],
]);

export const BREAKPOINTS_MEDIA: Map<Breakpoint, string> = new Map(
  Array.from(BREAKPOINTS_MAP.entries()).map(([key, value]) => [
    key,
    // Intentionally use px as unit instead of px so browser doesn't need CSS to be loaded to evaluate the sizes
    `min-width: ${value}px`,
  ]),
);

export type BreakpointKey = Breakpoint | number;

export type ImageBreakpointSrcSetSizes = ReadonlyArray<readonly [BreakpointKey, number]>;

/** Internal: layout-only media query tuples consumed by `getResponsiveImageProps` */
export type ImageSrcSetSizes = [
  /** The media query */
  string,
  /** The layout width (px) */
  number,
][];

export type CarmaImageFit = 'cover' | 'fit';

export const resolveBreakpointMinWidth = (key: BreakpointKey): number => {
  if (key === 'default') {
    return 0;
  }

  if (typeof key === 'number') {
    return key;
  }

  return BREAKPOINTS_MAP.get(key) ?? 0;
};
